import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useQueryClient } from '@tanstack/react-query';
import * as stylex from '@stylexjs/stylex';
import '@astryxdesign/core/theme/tokens.stylex';
import { spacingVars } from '@astryxdesign/core/theme/tokens.stylex';
import { Banner } from '@astryxdesign/core/Banner';
import { formatDateTime } from '@qronstat/i18n';
import { useFreshness } from '../api/hooks';
import { useApp } from './context';
import { useOnline } from './useOnline';
const staleAfterMs = 3 * 60 * 60 * 1000;
function lastSuccess(client: ReturnType<typeof useQueryClient>): number {
  let max = 0;
  for (const q of client.getQueryCache().getAll()) if (q.state.status === 'success' && q.state.dataUpdatedAt > max) max = q.state.dataUpdatedAt;
  return max;
}
export function StatusBanners() {
  const intl = useIntl();
  const client = useQueryClient();
  const online = useOnline();
  const {
    locale
  } = useApp();
  const freshness = useFreshness(online);
  const [offlineSince, setOfflineSince] = useState<number | null>(null);
  useEffect(() => {
    if (!online) setOfflineSince(lastSuccess(client));else setOfflineSince(null);
  }, [online, client]);
  const refreshedAt = freshness.data?.refreshedAt ? Date.parse(freshness.data.refreshedAt) : null;
  const stale = refreshedAt !== null && Date.now() - refreshedAt > staleAfterMs && (freshness.data?.sources.some(s => s.failing) ?? false);
  if (online && !stale) return null;
  return <div className="x1pzlopt x1vlblms x78zum5 xdt5ytf x1txdalj">
      {!online ? <Banner status="warning" collapsible={false} title={offlineSince ? intl.formatMessage({
      id: 'app.offlineSince'
    }, {
      time: formatDateTime(new Date(offlineSince), locale)
    }) : intl.formatMessage({
      id: 'app.offline'
    })} /> : null}
      {online && stale && refreshedAt !== null ? <Banner status="info" collapsible={false} title={intl.formatMessage({
      id: 'app.dataStale'
    }, {
      time: formatDateTime(new Date(refreshedAt), locale)
    })} /> : null}
    </div>;
}